<template>
    <div id="product-details">
        <div class="mt-4"></div>
        <section id="product-details-section" class="">
            <div class="product-details-container">
                <div class="row">
                    <template v-if="$page.props.notices.length > 0 && $page.props.notices_show">
                        <Notice :notice="notice" :key="notice.name" v-for="notice in $page.props.notices"></Notice>
                    </template>
                    <div class="col-lg-5 product-lg-image border">
                        <TikTokVideo :html="product.tiktok_video" />
                    </div>
                    <div class="col-lg-7 product-all-description">
                        <div class="title-date-catagory">
                            <h3 class="pd-title mt-2 text-capitalize">{{ product.title }}</h3>
                            <h3 style="font-size: 1rem !important;" class="pd-title mt-2 text-capitalize" v-if="product.title_en && (product.title != product.title_en)">Translation: {{ product.title_en }}</h3>
                            <h6 class="text-secondary mt-2">
                                <em>{{ product.added_date }}</em>
                                <Bookmark type="detail" :is-winning="product.is_winning" :id="product.id" :is-bookmark="product.bookmarked" :key="product.id+product.bookmarked" />
                            </h6>
                            <h6><em>{{ product.country_title }}</em></h6>
                            <h4 class="mt-2 buttons">
                                <button class="btn btn-sm btn-orange" v-for="category in product.product_categories">{{ category.title }}</button>
                            </h4>
                            <p v-if="product.bookmark" class="mt-2 alert alert-secondary p-2"><strong>Notes:</strong> {{ product.bookmark.notes }}</p>
                        </div>

                        <div class="row analytics-profit-cost mt-4">
                            <div class="col-md-9 col-12 analytics profit-cost p-2" v-if="product.product_cost">
                                <div class="wrapper">
                                    <h5>Your Profit Cost</h5>
                                    <div class="trends-sound">
                                        <div class="box">
                                            <h1>{{ product.selling_price }}</h1>
                                            <h5>Selling Price</h5>
                                        </div>
                                        <div class="box">
                                            <h1 class="text-danger fw-bold">{{ product.product_cost }}</h1>
                                            <h5>Product Cost</h5>
                                        </div>
                                        <div class="box">
                                            <h1 class="text-success fw-bold">{{ product.product_profit }}</h1>
                                            <h5>Profit Margin</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <!-- source and review section -->
                        <div class="source-and-review p-0" v-if="product.sources.length">
                            <div class="row">
                                <div class="col-md-6 p-3" v-for="source in product.sources">
                                    <div class="wrapper">
                                        <h6>Source: <span>{{ source.title }}</span></h6>
                                        <h6>Price: <span>{{ source.price }}</span></h6>
                                        <h6>Reviews: <span>{{ source.reviews }}</span></h6>
                                        <h6 v-if="source.order">Orders: <span>{{ source.order }}</span></h6>
                                        <h6>
                                            Rating:
                                            <span v-if="source.rating" :title="source.rating" data-bs-toggle="tooltip">
                                                <span v-if="source.rating > 0" class="iconify text-warning" :data-icon="source.rating <= 0.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 1" class="iconify text-warning" :data-icon="source.rating <= 1.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 2" class="iconify text-warning" :data-icon="source.rating <= 2.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 3" class="iconify text-warning" :data-icon="source.rating <= 3.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                                <span v-if="source.rating > 4" class="iconify text-warning" :data-icon="source.rating <= 4.7 ? 'bi:star-half' : 'bi:star-fill'" data-inline="false"></span>
                                            </span>
                                            <span v-else>N/A</span>
                                        </h6>
                                        <a :href="source.link" v-if="source.link" class="btn btn-sm theme-btn py-2 mt-3 btn-orange" target="_blank">Visit Link</a>
                                    </div>
                                </div>

                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <!-- links part -->
                        <div class="links-part" v-if="product.links.length > 0">
                            <div class="wrapper">
                                <h5 class="mb-3"><span class="iconify" data-icon="heroicons-solid:link" data-inline="false"></span> <span>Links</span></h5>
                                <ul class="list-unstyled ps-4">
                                    <li v-for="link in product.links" >
                                        <a v-if="link.src.length > 0" target="_blank" :href="link.src">{{link.title }}</a>
                                    </li>
                                </ul>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                        <div class="source-and-review p-0 mt-4" v-if="product.video_1">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="ratio ratio-4x3">
                                        <iframe width="560" height="315" :src="'https://www.youtube.com/embed/'+product.video_1" :title="product.title" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
                                    </div>
                                </div>
                            </div>
                            <hr style="height: 3px" class="my-3" />
                        </div>

                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>



import RecordNotFound from "@s/Components/RecordNotFound";
import Bookmark from "../components/Bookmark";
import VueEasyLightbox from 'vue-easy-lightbox'
import DetailGallery from "./Gallery";
import DetailDescription from "./Description";
import GoogleTrend from "@u/Pages/Product/components/GoogleTrend";
import Notice from "../components/Notice";
import VueApexCharts from "vue3-apexcharts";
import TikTokVideo from "./TikTokVideo";

export default {
    name: 'DetailTikTokPage',
    components: {
        DetailDescription,
        TikTokVideo,
        Bookmark,
        RecordNotFound,
        Notice,
        VueEasyLightbox,
        VueApexCharts,
    },
    props: ["product", "data", "pageTitle"],
    data() {
        return {
            fbAdsImgVisible: false,
            fbAdsImgIndex: 0,
            defaultSliderImage: this.product.featured_image,
            embed: {
                modalId: 'detail-st-modal',
                id: 'detail-st',
                keyword: '',
                country: 'US',
                counter: 0,
            },
        }
    },
    mounted() {

    },
    created(){
        document.title = this.pageTitle;
    },
    methods: {

    }
}
</script>
<style>
[v-cloak] { display:none; }
</style>
